import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setaddress] = useState("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        address: address,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="hidden xl:block fixed left-0 bottom-0 w-full h-fit py-2 px-[calc((100%-var(--container))/5)] bg-primary z-40">
      <div className=" relative w-full h-full flex mx-auto items-center gap-3 2xl:gap-6 3xl:gap-8 border-3">
        <div className="relative w-fit h-full flex items-center gap-3 2xl:gap-6 3xl:gap-8">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-auto h-full max-h-14 min-w-28"
              src="/images/whiteLogo.png"
              alt="number"
              width={461}
              height={168}
            />
          </div>
          <div className="relative w-fit h-full cursor-pointer">
            <img
              className="!relative w-auto h-full max-h-11"
              src="/images/quickNum.png"
              alt="number"
              width={584}
              height={107}
            />
          </div>
        </div>
        <div className=" relative w-fit h-full min-w-[600px] grid grid-cols-7 gap-3 2xl:gap-6 3xl:gap-8">
          <div className="col-span-2 relative w-full h-full">
            <label
              htmlFor="name1"
              className=" absolute left-1.5 z-10 top-2 lg:text-lg"
            >
              <span className="text-[var(--red-color)]">*</span> 이름
            </label>
            <input
              type="text"
              value={name}
              className="!pl-12"
              id="name1"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-span-2 relative w-full h-full">
            <label
              htmlFor="phone1"
              className=" absolute left-1.5 z-10 top-2 lg:text-lg"
            >
              <span className="text-[var(--red-color)]">*</span> 연락처
            </label>
            <input
              className="!pl-16"
              type="text"
              id="phone1"
              value={phone}
              maxLength={11}
              onChange={(e) =>
                setPhone(
                  e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*)\./g, "$1")
                )
              }
            />
          </div>
          <div className="col-span-3 relative w-full h-full">
            <label
              htmlFor="contents1"
              className=" absolute left-1.5 z-10 top-2 lg:text-lg"
            >
              <span className="text-[var(--red-color)]">*</span> 주소
            </label>
            <div>
              <input
                className="!pl-20"
                type="text"
                value={address}
                id="contents1"
                onChange={(e) => setaddress(e.target.value)}
              />
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={handlerPostContact}
          disabled={loading}
          className=" relative w-fit h-fit pt-1 px-8 bg-[#ffcd4a] text-[var(--red-color)] rounded-sm"
        >
          <h4 className="font-light">전송하기</h4>
        </button>
      </div>
    </div>
  );
};

export default QuickBar;
